export enum ShoddyPenalties {
    NotShoddy = 0,
    Shoddy = -2,
}
